import { NgbDateStruct, NgbTimeStruct } from "@ng-bootstrap/ng-bootstrap";
import { IssueType1Model, IssueType2Model } from ".";
import { SiteModel } from "./siteModel";
import { TenantsModel } from "./tenantModel";

export class IssueWebModel {
    public IssueWebId: number;

    public DateCreated: Date;
    public DateChecked: Date;
    public DateFinished: Date;

    public AccountId: number;
    public SiteId: number;

    public Site: SiteModel;

    public TenantId: number;

    public Tenant: TenantsModel;

    public IssueType1Id: number;

    public IssueType1: IssueType1Model;
    public IssueType2: IssueType2Model;

    public IssueType2Id: number;
    public Email: string;
    public Phone: string;
    public ContactName: string;
    public Address: string;
    public ApartmentNumber: string;
    public Image: string | ArrayBuffer;
    public Image2: string;
    public Image3: string;
    public Image4: string;
    public Image5: string;

    public Description: string;
    public IsPolice: boolean;
    public Status: string;
    public ReminderEmailSentCount: number;
    public ImageThumb: string;
    public IssueWebHistories: any;
    public IssueType3: any[];
    public IssueNumber: number;

    public IsDateSetFromUI: boolean;
    public Date: NgbDateStruct;
    public Time: NgbTimeStruct;
    public Timezone: string;

    public SaveOnlyData: boolean = false;
    public IsPublic: boolean;
}

export class IssueWebHistory {
    public IssueWebHistoryId: number;
    public ReactedBy: string;
    public Minutes
    public MaterialCost
    public DescriptionExternal: string;
    public DescriptionInternal: string;
    public DateTime: Date;
    public Date: NgbDateStruct;
    public Time: NgbTimeStruct;
    public IsWarranty: boolean;
    public IsRent: boolean;
    public IsDamage: boolean;
    public IssueWebHistoryType: string;
    public IsPrivate: boolean;
    public VisibleToPublic: boolean = true;
    public IssueWebId: number;
}



// WEBPACK FOOTER //
// ./src/app/models/issueWebModel.ts